<template>
    <div class="page bg-gray pb-fixed-btn">
        <backTitleBar></backTitleBar>
        <div class="shop-register-state">
            <div class="text color-999">基本信息</div>
            <div class="alifont icon-jianjinlv color-999"></div>
            <div class="text color-main">公司信息</div>
            <div class="alifont icon-jianjinhei color-main"></div>
            <div class="text color-999">店铺设置</div>
        </div>
        <div class="content pd-025">
            <div class="card mt-20">
                <div class="card-title">结算信息</div>
                <div class="pd-020">
                    <div class="input-field bd-bot click" @click="showPop = true">
                        <div class="fs-32 color-333 left required">开户银行 </div>
                        <div class="field-content" :class="formItem.bankName ? 'color-333':'color-999'">{{formItem.bankName || '请选择开户银行'}}</div>
                        <div class="alifont icon-fanhui1 fs-30 color-999 right"></div>
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">账号名称</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.bankUname" placeholder="请输入账号名称" />
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">银行账户</div>
                        <van-field class="input" type="digit" :clearable="true" v-model="formItem.bankNo" placeholder="请输入银行账户" />
                    </div>
                    <div class="input-field">
                        <div class="fs-32 color-333 left required">开户行地址</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.bankAddress" placeholder="请输入开户行地址" />
                    </div>
<!--                    <div class="input-field">-->
<!--                        <div class="fs-32 color-333 left required">账户 <br/>结算周期</div>-->
<!--                        <van-radio-group  class="input" v-model="formItem.clearingCycle">-->
<!--                            <van-radio name="1">T+1</van-radio>-->
<!--                            <van-radio name="7">T+7</van-radio>-->
<!--                        </van-radio-group>-->
<!--                    </div>-->
                </div>
            </div>
            <div class="card mt-20">
                <div class="card-title">资质信息</div>
                <div class="pd-020">
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">营业执照<br/>单位名称</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.licenseName" placeholder="请输入营业执照单位名称" />
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">营业执照号</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.licenseNo" placeholder="请输入营业执照号" />
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">法人姓名</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.identityName" placeholder="请输入法人姓名" />
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">法人<br/>身份证号</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.identityCard" placeholder="请输入法人身份证号" />
                    </div>
                    <div class="input-field bd-bot">
                        <div class="fs-32 color-333 left required">注册地址</div>
                        <van-field class="input" type="text" :clearable="true" v-model="formItem.regAddress" placeholder="请输入注册地址" />
                    </div>
                    <div class="filed-input-box bd-bot">
                        <div class="required fs-32 color-333">上传清晰营业执照</div>
                        <div class="fs-28 color-999 pl-15">(支持jpg、bmp格式图片，大小不要超过1M/张)</div>
                        <div class="flex" style="flex-wrap: wrap;">
                            <div class="pic-box" v-show="formItem.licensePicView">
                                <img :src="formItem.licensePicView" alt="" >
                                <div class="clean" @click="delImg('licensePicView')"></div>
                            </div>
                            <van-uploader v-model="imgList" preview-size="1.45rem" :preview-image="false" :after-read="afterReadLicense" v-show="!formItem.licensePicView"/>
                        </div>
                    </div>
                    <div class="filed-input-box bd-bot">
                        <div class=" fs-32 color-333">上传其他清晰证件</div>
                        <div class="fs-28 color-999 pl-15">(支持jpg、bmp格式图片，大小不要超过1M/张)</div>
                        <div class="flex" style="flex-wrap: wrap;">
                            <div class="pic-box" v-show="formItem.otherPicView">
                                <img :src="formItem.otherPicView" alt="" >
                                <div class="clean" @click="delImg('otherPicView')"></div>
                            </div>
                            <van-uploader v-model="imgList" preview-size="1.45rem" :preview-image="false" :after-read="afterReadOther" v-show="!formItem.otherPicView"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="fixed-bot">
            <div class="btn click" @click="submitForm()">下一步</div>
        </div>



        <van-popup v-model="showPop" position="bottom">
            <van-picker show-toolbar :columns="dicts['bank_code']" value-key="codename"  @cancel="showPop = false" @confirm="onConfirm"  />
        </van-popup>
    </div>
</template>

<script>
    import backTitleBar from "@/components/titleBar/backTitleBar"
    import initDict from "@/mixins/initDict"
    import uploadImg from "@/api/uploadImg"
    import inputFix from "@/mixins/inputBugFix"
    export default {
        name: "companyInfo",
        components:{backTitleBar},
        mixins:[initDict,inputFix],
        data(){
            return{
                formItem:JSON.parse(localStorage.getItem('registerInfo')) || {},
                imgList:[],
                showPop:false,
                registerInfo:JSON.parse(localStorage.getItem('registerInfo')) || {},
            }
        },
        created(){
            // 加载数据字典
            let codeList = [
                'bank_code',
            ]
            this.getThisDict(codeList)
        },
        methods:{
            onConfirm(value){
                this.$set(this.formItem,'bankCode',value.code);
                this.$set(this.formItem,'bankName',value.codename);
                this.showPop = false;
            },


            //删除图片
            delImg(field){
                this.$set(this.formItem,field,'')
            },
            //选中图片后上传服务器
            async afterReadLicense(file){
                let result = await uploadImg(file.file,'shop');
                this.setField(result,'licensePic','licensePicView')
            },
            async afterReadOther(file){
                console.log("读取文件成功：",file)
                let result = await uploadImg(file.file,'shop');
                this.setField(result,'otherPic','otherPicView')
            },
            setField(result,picField,picViewField){
                this.$set(this.formItem,picField,result.fileUrl)
                this.$set(this.formItem,picViewField,result.fileUrlView)
            },


            submitForm(){
                let form = this.formItem
                if(!form.bankName || !form.bankUname || !form.bankNo || !form.bankAddress){
                    this.$toast("请填写必填项目");
                    return
                }
                if(!form.licenseName || !form.licenseNo || !form.identityName || !form.identityCard || !form.regAddress){
                    this.$toast("请填写必填项目");
                    return
                }
                if(!form.licensePicView){
                    this.$toast("请上传营业执照");
                    return
                }
                let params = {
                    bankName: form.bankName,
                    bankUname: form.bankUname,
                    bankNo: form.bankNo,
                    bankAddress: form.bankAddress,
                    // clearingCycle:form.clearingCycle,
                    shopName: form.shopName,
                    licenseName: form.licenseName,
                    licenseNo: form.licenseNo,
                    identityName: form.identityName,
                    identityCard: form.identityCard,
                    regAddress: form.regAddress,
                    licensePic: form.licensePic,
                }
                if(form.otherPic){
                    params.otherPic = form.otherPic
                }
                this.registerInfo = Object.assign({}, this.formItem, params);
                localStorage.setItem('registerInfo', JSON.stringify(this.registerInfo));
                this.$router.push({name: 'shopRegisterShopSetting'});
            },
        }
    }
</script>

<style scoped lang="scss">
    .van-radio{
        margin-bottom: .1rem;
        &:last-child{
            margin-bottom: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// companyInfo.vue?577c19a9